import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const WarningYellow: FC<SvgIconProps> = (props: SvgIconProps) => (
  <SvgIcon width="20" height="20" fill="none" {...props}>
    <path d="m10 .82 9.77 17.097H.23L10 .82Z" fill="#FC0" />
    <path d="M10.833 12.5v-5H9.166v5h1.667ZM10.833 15v-1.667H9.166V15h1.667Z" fill="#333" />
  </SvgIcon>
)
